<div class="tw-flex tw-flex-col tw-gap-3">
  <!-- Hero card -->
  <div
    class="tw-rounded-xl tw-overflow-hidden tw-shadow-card-elevated tw-border tw-border-white dark:tw-border-color-border-subtle"
    [style]="
      data().direction === TransactionDirection.In
        ? 'will-change: transform; background: linear-gradient(135deg, var(--dt-surface-in) 0%, var(--dt-surface-elevated) 100%)'
        : 'will-change: transform; background: linear-gradient(135deg, var(--dt-surface-out) 0%, var(--dt-surface-elevated) 100%)'
    "
  >
    <div class="tw-p-5 tw-flex tw-flex-col tw-gap-3">
      <!-- Icon + title -->
      <div class="tw-flex tw-items-center tw-gap-3">
        <icon
          [name]="'receipt2'"
          [size]="5"
          class="tw-p-2.5 tw-rounded-full tw-shadow-card-elevated"
          [ngClass]="
            data().direction === TransactionDirection.In
              ? 'tw-bg-dt-surface-in tw-text-dt-text-in-primary'
              : 'tw-bg-dt-surface-out tw-text-dt-text-out-primary'
          "
        ></icon>
        <span class="tw-text-xl tw-text-dt-text-headings tw-font-medium">{{
          data().description
        }}</span>
      </div>

      <!-- Amount glass panel -->
      <!-- Colours as classes, not inline, so the dark: variants can override them. -->
      <div
        class="tw-rounded-lg tw-px-4 tw-py-3 tw-flex tw-flex-col tw-gap-1.5 tw-bg-white/[0.52] tw-border tw-border-white/80 dark:tw-bg-white/[0.06] dark:tw-border-white/10"
        style="
          backdrop-filter: blur(18px) saturate(1.5);
          -webkit-backdrop-filter: blur(18px) saturate(1.5);
        "
      >
        <!-- Amount + currency -->
        <div class="tw-flex tw-items-baseline tw-gap-1.5">
          <span
            class="tw-text-3xl tw-font-semibold tw-font-D-DIN-PRO xs:tw-text-xl"
            style="font-variant-numeric: tabular-nums"
            [ngClass]="
              data().direction === TransactionDirection.In
                ? 'tw-text-dt-text-in-primary'
                : 'tw-text-dt-text-out-primary'
            "
            >{{ data().direction !== TransactionDirection.In ? "-" : ""
            }}{{ displayAmount() | number: "1.2-2" }}</span
          >
          <span class="tw-text-sm tw-font-medium tw-text-dt-text-secondary">{{
            isStockOrOtherAccount() && stockOtherData()
              ? stockOtherData().baseCurrencySymbol
              : data().transactionSymbol.symbol
          }}</span>
        </div>

        <!-- Direction chip + date -->
        <div class="tw-flex tw-items-center tw-gap-2">
          <span
            class="tw-text-sm tw-font-medium tw-rounded-full tw-px-3 tw-py-0.5"
            [ngClass]="
              data().direction === TransactionDirection.In
                ? 'tw-text-dt-text-in-primary tw-bg-dt-surface-in tw-border tw-border-solid tw-border-dt-border-in'
                : 'tw-text-dt-text-out-primary tw-bg-dt-surface-out tw-border tw-border-solid tw-border-dt-border-out'
            "
            >{{ data().direction }}</span
          >
          <span class="tw-text-base tw-text-dt-text-headings">{{
            data().date | date: "d MMM yyyy"
          }}</span>
        </div>
      </div>

      <!-- Stock / other: symbol amount + unit price -->
      @if (isStockOrOtherAccount()) {
        <div class="tw-grid tw-grid-cols-[minmax(80px,auto)_1fr] tw-gap-x-3 tw-gap-y-3 tw-px-1">
          <label class="transaction-details-label">{{ "symbolAmount" | i18n }}</label>
          <span class="tw-text-base tw-font-medium tw-text-dt-text-headings">
            {{ data().transactionSymbol.amount | number: "1.2-2" }}
            <span class="tw-font-normal tw-text-dt-text-secondary">{{
              data().transactionSymbol.symbol
            }}</span>
          </span>
          @if (stockOtherData()) {
            <label class="transaction-details-label">{{ "unitPrice" | i18n }}</label>
            <span class="tw-text-base tw-font-medium tw-text-dt-text-headings">
              {{ stockOtherData().unitPrice | number: "1.2-2" }}
              <span class="tw-font-normal tw-text-dt-text-secondary">{{
                stockOtherData().baseCurrencySymbol
              }}</span>
            </span>
          }
        </div>
      }
    </div>
  </div>

  <!-- Details card -->
  <div
    class="tw-rounded-xl tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-shadow-card-elevated"
  >
    <div class="tw-p-5 tw-flex tw-flex-col tw-gap-5">
      <!-- SOURCE -->
      <div class="tw-flex tw-items-center tw-gap-5">
        <label class="transaction-details-label tw-w-28 tw-shrink-0">{{ "source" | i18n }}</label>
        <!-- min-w-0 + wrap so a long source chip or provider logo stays inside the card on narrow screens -->
        <div class="tw-flex tw-flex-1 tw-flex-wrap tw-items-center tw-gap-2 tw-min-w-0">
          <span
            class="tw-max-w-full tw-break-words tw-rounded-full tw-px-3 tw-py-0.5 tw-text-sm tw-font-bold tw-capitalize tw-border tw-border-orange-200 tw-bg-orange-50 tw-text-orange-800 dark:tw-border-color-status-warning-border dark:tw-bg-color-status-warning-bg dark:tw-text-color-status-warning-text"
            ><span class="tw-text-xs tw-text-orange-300 dark:tw-text-color-status-warning-icon"
              >● </span
            >{{
              (isManual() ? InstitutionOriginEnum.manual : InstitutionOriginEnum.autoFetch) | i18n
            }}</span
          >
          @if (originImageExtension()) {
            <img
              loading="lazy"
              [src]="'../../../../../images/' + origin() + '.' + originImageExtension()"
              [alt]="origin() + ' icon'"
              class="tw-w-16 tw-h-4 tw-max-w-full"
            />
          }
        </div>
      </div>

      <!-- ACCOUNT -->
      <div class="tw-flex tw-items-center tw-gap-5">
        <label class="transaction-details-label tw-w-28 tw-shrink-0">{{ "account" | i18n }}</label>
        <span
          class="tw-min-w-0 tw-break-words tw-text-base tw-font-medium tw-text-dt-text-headings"
          >{{ data().source }}</span
        >
      </div>

      <!-- DESCRIPTION + edit button -->
      <div class="tw-flex tw-items-center tw-justify-between">
        <div class="tw-flex tw-items-center tw-gap-5 tw-flex-1 tw-min-w-0">
          <label class="transaction-details-label tw-w-28 tw-shrink-0">{{
            "description" | i18n
          }}</label>
          <span
            class="tw-text-base tw-font-medium tw-text-dt-text-headings tw-truncate"
            [title]="data().description"
            >{{ data().description }}</span
          >
        </div>
        @if (isManual()) {
          <button
            (click)="openEditTransaction()"
            class="tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-rounded-lg tw-p-1 tw-ml-2 tw-flex-shrink-0"
          >
            <icon
              [name]="'edit'"
              [currentColor]="'primary'"
              [size]="6"
              class="tw-rounded-lg tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-border-primary tw-border-[1.5px] tw-p-1.5 tw-shadow-neuomorphic-raised"
            ></icon>
          </button>
        }
      </div>
    </div>
  </div>

  <!-- Categories card -->
  <div
    class="tw-rounded-xl tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-shadow-card-elevated"
  >
    <div class="tw-p-5">
      <!-- Header -->
      <div class="tw-flex tw-items-center tw-justify-between">
        <label class="transaction-details-label">{{ "categories" | i18n }}</label>
        @if (isManual()) {
          <button
            (click)="goCategorySetting()"
            class="tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-rounded-lg tw-p-1"
          >
            <icon
              [name]="'edit'"
              [currentColor]="'primary'"
              [size]="6"
              class="tw-rounded-lg tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-border-primary tw-border-[1.5px] tw-p-1.5 tw-shadow-neuomorphic-raised"
            ></icon>
          </button>
        }
      </div>

      <!-- Chips -->
      <div class="tw-flex tw-flex-wrap tw-gap-2 tw-mt-3">
        @for (category of categories(); track $index) {
          <span
            class="tw-rounded-3xl tw-px-3 tw-py-1.5 tw-shadow-neuomorphic-inset tw-text-dt-text-action tw-font-bold"
            >{{ category.name }}</span
          >
        }
      </div>
    </div>
  </div>

  <!-- Transfer / conversion link (beta) -->
  @if (linkInfo().isLinked) {
    <div
      class="tw-rounded-xl tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-shadow-card-elevated"
    >
      <div class="tw-p-5 tw-flex tw-items-center tw-justify-between tw-gap-3">
        <div class="tw-flex tw-items-center tw-gap-3 tw-min-w-0">
          <label class="transaction-details-label tw-shrink-0">{{ "link" | i18n }}</label>
          <!-- linkType is null when the partner is missing from the enriched set -->
          @if (linkInfo().linkType; as linkType) {
            <app-link-type-badge [type]="linkType"></app-link-type-badge>
          }
        </div>
        <button
          (click)="unlink()"
          class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5 tw-text-dt-text-action tw-font-bold"
        >
          <icon [name]="'link'" [size]="4" class="tw-text-dt-text-action"></icon>
          <span class="tw-cursor-pointer">{{ "unlink" | i18n }}</span>
        </button>
      </div>
    </div>
  }

  <!-- Manual link entry point (beta, not yet linked) -->
  @if (canManualLink()) {
    <div
      class="tw-rounded-xl tw-bg-dt-surface-card dark:tw-bg-dt-surface-elevated tw-shadow-card-elevated"
    >
      <div class="tw-p-5 tw-flex tw-items-center tw-justify-between tw-gap-3">
        <label class="transaction-details-label tw-shrink-0">{{ "link" | i18n }}</label>
        <button
          (click)="openLinkPicker()"
          class="tw-flex tw-flex-shrink-0 tw-items-center tw-gap-1.5 tw-text-dt-text-action tw-font-bold"
        >
          <icon [name]="'link'" [size]="4" class="tw-text-dt-text-action"></icon>
          <span class="tw-cursor-pointer">{{ "linkToAnotherTransaction" | i18n }}</span>
        </button>
      </div>
    </div>
  }

  <!-- Delete -->
  @if (isManual()) {
    <div class="tw-flex tw-justify-center tw-mt-5">
      <button
        class="danger tw-bg-transparent tw-cursor-auto tw-flex tw-items-center tw-gap-1.5"
        data-testid="delete-transaction-button"
        (click)="delete()"
      >
        <icon
          [name]="'trash-bin'"
          [size]="4"
          class="tw-text-dt-text-error tw-cursor-pointer"
        ></icon>
        <span class="tw-cursor-pointer">{{ "deleteThisTransaction" | i18n }}</span>
      </button>
    </div>
  }
</div>
